class HideCuota {
    constructor(button, cuota) {
        this.cuota = document.querySelector(cuota);
        this.button = document.querySelector(button);
        this.mainContainer = document.querySelector('.formBorder');
        this.infoPlanes = document.querySelector('.planesDiv--info-planes');
        this.wrapper = document.querySelector('.planesDiv').clientHeight;
        this.button.addEventListener('click', (e) => {
            this.toggleCuota();
        })
    }


toggleCuota() {
    let expand = document.querySelector('.MuiCollapse-hidden');
    var form = document.querySelector('.formBorder');
   

    if (expand == null){
        /* this.cuota.classList.remove('cuota--hide'); */
        if(form) {
          
            form.style.top =  this.wrapper - form.clientHeight + 'px'; 
        }
      
       
    } else {
       
        /* this.cuota.classList.add('cuota--hide');  */
        
    }
}
}

export {HideCuota};